import { Text } from "@chakra-ui/react";
import { Flex } from "@chakra-ui/layout";
import TimelineLogs from "components/TimelineLogs";
import { HistoricoManutencaoLogs } from "core/features/manutencao/typings/index";

interface HistoricoProps {
  logs: HistoricoManutencaoLogs[];
}

function Historico({ logs }: HistoricoProps) {
  return (
    <Flex flexDir="column">
      <Text fontSize={20} mb={1}>
        Histórico
      </Text>
      {logs.map((log, index) => (
        <TimelineLogs
          data={{ title: log.title, data: log.data, message: log.message }}
          key={index}
        />
      ))}
    </Flex>
  );
}

export default Historico;
